import * as angular from "angular";
import * as _ from "lodash";
import {ViewSettingsHolderType, ViewSettingsType} from "../models/view-settings.model";
import {SyncService} from "../../persistence-layer/sync-service.service";
import {CommonsAlertsService} from "./commons-alerts.service";
import {ViewSettingsService} from "./view-settings-service.service";
import {LocationType} from "../types/location.type";
import {CommonsService} from "./commons-service.service";
import {ServicesUpdateMetadataRequestModel} from "../../deliveries/models/services-update-metadata-request.model";
import {SplitService} from "./split-service.service";
import {FirebaseService} from "../../persistence-layer/firebase.service";
import {OperationalContactModel} from "../angular/models/operational-contact.model";

export class CommonsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private syncService: SyncService, private firebaseService: FirebaseService,
              private commonsConstants,
              private commonsService: CommonsService,
              private splitService: SplitService, private moment) {
  }

  preferencesValue(event, header, property, type) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/preferences-value-dialog.html').default,
      controller: function ($scope) {

        $scope.header = header;
        $scope.type = type;
        $scope.property = angular.copy(property);
        $scope.typeOf = property;

        //////////////////////

        $scope.ok = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            self.$mdDialog.hide($scope.property);
          }
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }

  siteFilters(event, includeFilters, filters, selectedQuickFilterId, pageName?, queryMap?, excludeIdsMap?, optionIdsMap?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/filters-dialog.html').default,
      controller: function ($scope, IAMPermissions, viewSettingsService: ViewSettingsService, $state) {

        $scope.includeFilters = includeFilters;
        $scope.filters = filters;
        $scope.pageName = pageName || $state?.current?.name || 'routes';
        $scope.queryMap = queryMap;
        $scope.excludeIdsMap = excludeIdsMap;
        $scope.optionIdsMap = optionIdsMap;
        $scope.selectedQuickFilterId = selectedQuickFilterId;

        $scope.loading = false;
        $scope.selectedQuickFilter = undefined;
        $scope.quickFilters = undefined;
        $scope.quickFilterToCreate = undefined;
        $scope.shouldUpdateSelectedQuickFilter = false;


        $scope.getQuickFilters = () => {
          $scope.loading = true;
          viewSettingsService.getByUser($scope.pageName, ViewSettingsType.Filter)
            .then((quickFilters) => {
              $scope.quickFilters = quickFilters;
              const targetId = $scope.selectedQuickFilter?.id || $scope.selectedQuickFilterId;
              if (targetId) {
                $scope.selectedQuickFilter = _.find(quickFilters, (qf) => {
                  return qf.id === targetId;
                })
              }
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        if (IAMPermissions.hasPermission('viewSettings.list')) {
          $scope.getQuickFilters();
        }

        ///////////////////////////////////////////////////

        $scope.canCreateNewFilter = () => {
          let canCreateNew = false;
          const subFilters = ['noArea', 'noPickUpArea', 'noDropOffArea'];
          _.forOwn($scope.filters, (value, key) => {
            if (subFilters.includes(key) && !value) {
              return;
            } else if (_.isArray(value) ? !!value.length : !_.isUndefined(value)) {
              canCreateNew = true;
            }
          })
          return canCreateNew;
        }

        $scope._createQuickFilter = () => {
          $scope.quickFilterToCreate.settings = $scope.filters;

          $scope.loading = true;
          viewSettingsService.createByUser($scope.quickFilterToCreate)
            .then((createdQuickFilter) => {
              $scope.selectedQuickFilter = createdQuickFilter;
              $scope.quickFilterToCreate = undefined;
              $scope.getQuickFilters();
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope._updateQuickFilter = () => {
          $scope.selectedQuickFilter.settings = $scope.filters;

          $scope.loading = true;
          viewSettingsService.updateByUser($scope.selectedQuickFilter.id, $scope.selectedQuickFilter)
            .then((updatedQuickFilter) => {
              $scope.selectedQuickFilter = updatedQuickFilter;
              $scope.getQuickFilters();
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope._deleteQuickFilter = () => {
          $scope.loading = true;
          viewSettingsService.deleteByUser($scope.selectedQuickFilter.id)
            .then(() => {
              $scope.quickFilters = _.filter($scope.quickFilters, (qf) => {
                return qf.id !== $scope.selectedQuickFilter.id;
              })
              $scope.selectedQuickFilter = undefined;
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.onQuickFilterSelect = (selectedQuickFilter) => {
          $scope.selectedQuickFilter = selectedQuickFilter;

          if (!!selectedQuickFilter) {
            $scope.filters = angular.copy(selectedQuickFilter.settings);
          } else {
            $scope.onReset();
          }
        }

        $scope.onDeleteSelectedQuickFilter = () => {
          $scope._deleteQuickFilter();
        }

        $scope.onShouldUpdateSelectedQuickFilterChange = (shouldUpdateSelectedQuickFilter) => {
          $scope.shouldUpdateSelectedQuickFilter = !shouldUpdateSelectedQuickFilter;
        }

        $scope.toggleCreateQuickFilterMode = (isEnabled) => {
          $scope.quickFilterToCreate = isEnabled ? {
            name: undefined,
            pageName: $scope.pageName,
            holderType: ViewSettingsHolderType.User,
            settingsType: ViewSettingsType.Filter
          } : undefined;
        }

        $scope.onChangeFilters = (filters) => {
          $scope.filters = filters;
        }

        $scope.onReset = () => {
          if ($scope.excludeIdsMap && $scope.filters.groupIds?.length) {
            $scope.excludeIdsMap.branchIds = [];
          }
          $scope.selectedQuickFilter = undefined;
          _.forOwn($scope.filters, (value, key) => {
            $scope.filters[key] = _.isArray(value) ? [] : undefined;
          })
        }

        $scope.onApply = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const updatedFilters = angular.copy($scope.filters);
              _.forOwn($scope.filters, (value, key) => {
                if (_.isUndefined(value) || _.isNull(value)) {
                  _.unset(updatedFilters, key);
                }
              })

              if (!_.isEqual(updatedFilters, $scope.selectedQuickFilter?.settings)) {
                $scope.selectedQuickFilter = undefined;
              }

              self.$mdDialog.hide({filters: $scope.filters, selectedQuickFilter: $scope.selectedQuickFilter});
            }
          }
        }

        $scope.onApplySaveChanges = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.quickFilterToCreate) {
                $scope._createQuickFilter();
              } else if ($scope.shouldUpdateSelectedQuickFilter) {
                $scope._updateQuickFilter();
              }
            }
          }
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }

  openPodImagePop(event, url, text, extraInfo, type: string) {
    this.$mdDialog.show({
      template: require('./../views/tmpl/image-popup.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.type = type;
        $scope.isVideo = type?.includes('video');
        $scope.link = url;
        $scope.text = text;
        $scope.extraInfo = extraInfo;

        $scope.cancel = () => {
          $mdDialog.cancel();
        };

        $scope.downloadFile = (ev) => {
          let downloadUrl = $scope.link;
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "test.jpg";
          document.body.appendChild(a);
          a.click();
          a.remove();
        }

      }
    });

  }

  printIkea(services) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/print-ikea-dialog.html').default,
      controller: function ($scope, commonsService: CommonsService, commonsAlertsService: CommonsAlertsService) {


        $scope.services = services;

        $scope.submitted = false;
        $scope.printerList = [];

        if (services.length > 1) {
          $scope.printerTypes = ["shippingDetails"];
        } else {
          $scope.printerTypes = ["shippingDetails", "stickersData"];
        }

        $scope.selectedPrinter = undefined;
        $scope.selectedPrintType = $scope.printerTypes[0];

        $scope.totalNumOfStickers = _getTotalNumOfStickers(services);
        $scope.selectedNumOfStickers = $scope.totalNumOfStickers || 1;

        if (services?.length < 2) {
          $scope.selectedDepotId = _.get(services[0], 'depotIds[0]');
        }

        $scope.depotIds = undefined;

        commonsService.getIkeaPrinters()
          .then((printers) => {
            $scope.printerList = printers
            $scope._setSelectedPrinterByType($scope.selectedPrintType);
          })

        //////////////////////

        function _getTotalNumOfStickers(services) {
          return _.reduce(_.flatMap(services, 'packageList'), (totalItems, p: any) => {
            return totalItems + p.count;
          }, 0) || 0;
        }

        $scope.onChangePrinterType = (selectedPrintType) => {
          $scope.selectedPrintType = selectedPrintType;
          $scope._setSelectedPrinterByType(selectedPrintType);
        }

        $scope.onChangeStickersAmount = (selectedNumOfStickers) => {
          $scope.selectedNumOfStickers = selectedNumOfStickers;
        }

        $scope.onChangePrinter = (selectedPrinter) => {
          $scope.selectedPrinter = selectedPrinter;
        }

        $scope.onChangeDepot = (selectedDepot) => {
          $scope.selectedDepotId = _.get(selectedDepot, 'id');
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.submitted = true;
              commonsService.printIkea(
                services.map(s => s.id),
                $scope.selectedPrinter.name,
                $scope.selectedPrintType,
                $scope.selectedNumOfStickers,
                $scope.selectedDepotId)
                .then((res) => {
                  commonsAlertsService.printSuccess();
                  self.$mdDialog.hide();
                })
                .catch((error) => {
                  commonsAlertsService.printError();
                })
                .finally(() => {
                  $scope.submitted = false;
                })
            }
          }
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

        $scope._setSelectedPrinterByType = (printerType) => {
          const printerNameToSelect = _.isEqual(printerType, 'stickersData') ? 'Hov_P1' : 'Hov_P2';
          $scope.selectedPrinter = _.find($scope.printerList, (p) => {
            return _.isEqual(p.name, printerNameToSelect);
          })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }

  infoDialog(header, description) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/info-dialog.html').default,
      controller: function ($scope) {

        $scope.header = header;
        $scope.description = description;

        //////////////////////

        $scope.continue = () => {
          self.$mdDialog.hide();
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }

  emailsDialog(event) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/emails-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        $scope.emailChips = [];
        $scope.note;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onEmailListChange = (list) => {
          $scope.emailChips = list;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.emailRecipients = _.map($scope.emailChips, 'name');
              self.$mdDialog.hide({
                emailRecipients: $scope.emailRecipients,
                note: $scope.note
              });
            }
          }
        }

      }
    })
  }

  stillThereConfirm(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/still-there-confirm.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        self.syncService.firebaseGoOffline();
        self.firebaseService.firebaseGoOffline();

        $scope.submit = (continueSession) => {
          self.syncService.firebaseGoOnline();
          self.firebaseService.firebaseGoOnline();
          self.$mdDialog.hide(continueSession);
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  note(event, ids?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/add-note-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, commonsService: CommonsService, $log) {

        $scope.ids = ids;
        $scope.note = {
          title: '',
          text: '',
          attachments: []
        };


        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then((result) => {
              _afterUpload(result);
            })
            .catch(() => {
              $log.info('Closed File Upload')
            })
        }

        function _afterUpload(uploadedResult) {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.note.attachments.push(attachment);
          }
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.note.attachments.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.note);
            }
          }
        }

      }
    });
  }

  timeSelection(range, date, isShowTimeWindowTab, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/commons/components/bringoz-time-picker/dialog/dialog-view.html',
      controller: function ($scope) {

        $scope.range = range;
        $scope.date = date;
        $scope.isShowTimeWindowTab = isShowTimeWindowTab
        $scope.currentTab = 'timePicker';
        $scope.min = self.moment($scope.date).startOf('day').valueOf();
        $scope.max = self.moment($scope.date).endOf('day').valueOf();
        //////////////////////////////////////////////////

        $scope.onTabSelected = (tab) => {
          $scope.currentTab = tab;
        }

        $scope.onTimeWindowChange = (timeWindow) => {
          $scope.timeWindow = timeWindow;
        }

        $scope.onTimeChanged = (from, to) => {
          $scope.range = {
            dateStart: from,
            dateEnd: to
          };
        }

        $scope.reset = () => {
          if ($scope.currentTab == 'timePicker') {
            let range = {
              dateStart: $scope.min,
              dateEnd: $scope.max
            };
            $scope.onTimeChanged(range.dateStart, range.dateEnd);
            self.$mdDialog.hide($scope.range);
          } else if ($scope.currentTab == 'timeSlot') {
            $scope.onTimeWindowChange(undefined);
            self.$mdDialog.hide($scope.range);
          }

        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

        $scope.submitTime = () => {
          if ($scope.currentTab === 'timeSlot') {
            $scope.range = {
              dateStart: self.moment($scope.date).hour($scope.timeWindow.fromHour).minute($scope.timeWindow.fromMinute).seconds(0).milliseconds(0).valueOf(),
              dateEnd: self.moment($scope.date).hour($scope.timeWindow.toHour).minute($scope.timeWindow.toMinute).seconds(0).milliseconds(0).valueOf()
            };
          }
          self.$mdDialog.hide($scope.range);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  dateSelection(event, calendarModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/commons/views/tmpl/date-range-picker-dialog.html',
      controller: function ($scope) {

        $scope.calendarModel = calendarModel;


        //////////////////////////////////////////////////

        $scope.isDisableDate = (date) => {
          return ($scope.calendarModel.min ? self.moment(date).isBefore(self.moment($scope.calendarModel.min)) : false) ||
            ($scope.calendarModel.max ? self.moment(date).isAfter(self.moment($scope.calendarModel.max)) : false);
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.calendarModel);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    });
  }

  editPassword(email?: string, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/commons/views/tmpl/edit-password-dialog.tmpl.html',
      controller: function ($scope) {

        $scope.passwordPolicy = self.splitService.getSitePasswordPolicy();
        $scope.password = undefined;
        $scope.verifyPassword = undefined;
        $scope.isShowPassword = false;

        $scope.zxExtras = email ?
          self.commonsService.buildZxExtras(email) :
          [];

        ////////////////////////////////////////////////////

        $scope.onChangePassword = (password) => {
          $scope.password = password;
        }

        $scope.onVerifyPasswordChange = (form) => {
          form['verifyPassword'].$setValidity('mismatch', _.isEqual($scope.password, $scope.verifyPassword));
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

        $scope.onUpdate = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            self.$mdDialog.hide($scope.password);
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  suspendSite(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/commons/views/tmpl/suspended-site-dialog.html',
      controller: function ($scope) {


        ////////////////////////////////////////////////////

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false,
      escapeToClose: false
    })
  }

  locationSelect(event, excludeIds, locationType?, locationId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/location-select-dialog.tmpl.html').default,
      controller: function ($scope) {
        $scope.excludeIds = excludeIds || [];
        $scope.locationType = locationType || LocationType.ACCOUNT;
        $scope.locationId = locationId;
        $scope.selectedLocationRef = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////

        $scope.onLocationTypeChange = (locationType) => {
          $scope.locationType = locationType;
          $scope.locationId = undefined;
        }

        $scope.onAccountSelect = (account) => {
          $scope.locationId = _.get(account, 'id');
          $scope.selectedLocationRef = account;
        }

        $scope.onDepotSelect = (depot) => {
          $scope.locationId = _.get(depot, 'id');
          $scope.selectedLocationRef = depot;
        }

        $scope.onCustomerSelect = (customer) => {
          $scope.locationId = _.get(customer, 'id');
          $scope.selectedLocationRef = customer;
        }


        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                locationType: $scope.locationType,
                locationId: $scope.locationId,
                location: $scope.selectedLocationRef
              });
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false,
      escapeToClose: false
    })
  }

  displayEntityLinksList(state: string, items: { id: string, name?: string }[], permission: string, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/entity-links-list.tmpl.html').default,
      controller: function ($scope) {
        $scope.state = state;
        $scope.items = items;
        $scope.permission = permission;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      escapeToClose: false
    })
  }

  attemptInfoDialog(attemptDetails?, subType?, fulfillmentId?, step?, stepPriceInfo?, attempt?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/attempt-info-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.fulfillmentId = fulfillmentId;
        $scope.step = step;
        $scope.subType = subType;
        $scope.stepPriceInfo = stepPriceInfo;
        $scope.attempt = attempt;
        $scope.attemptDetails = attemptDetails;

        $scope.close = self.$mdDialog.cancel;

      }
    });
  }

  selectColor(color, colorOptions?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/select-color.html').default,
      controller: function ($scope) {
        $scope.baseColor = color;
        $scope.color = color;
        $scope.colorOptions = colorOptions ? colorOptions : self.commonsConstants.colorPalletSmall

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////

        $scope.onBaseColorSelect = (color) => {
          $scope.baseColor = color;
          $scope.color = color;
        }

        $scope.onColorSelect = (color) => {
          $scope.color = color;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.color);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false,
      escapeToClose: false
    })
  }

  uploadFile(types?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/upload-file-dialog.html').default,
      controller: function ($scope) {
        $scope.file = undefined;
        $scope.types = types || '.pdf,.tif,.tiff,.bmp,.jpeg,.jpg,.gif,.png,.eps,.raw,.cr2,.nef,.orf,.sr2';

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.file);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      escapeToClose: true
    })
  }

  editExternalId(externalId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-external-id-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.externalId = externalId;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.confirm = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.externalId);
            }
          }
        }
      }
    })
  }

  importFileMapping(entity, entityPath) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/import-file-mapping-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.entity = entity;
        $scope.entityPath = entityPath;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSubmit = (filePreview) => {
          self.$mdDialog.hide(filePreview);
        }
      }
    })
  }

  uploadJSON(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/upload-json-dialog.html').default,
      controller: function ($scope, commonsAlertsService: CommonsAlertsService) {

        $scope.text = undefined;

        $scope.onRemoveAgents = (text) => {
          $scope.text = text;
        }

        function isValidJSON() {
          try {
            JSON.parse($scope.text);
          } catch (e) {
            return false;
          }
          return true;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          if (isValidJSON()) {
            self.$mdDialog.hide(JSON.parse($scope.text));
          } else {
            commonsAlertsService.invalidJsonError();
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  editMetaData(event, ids: string[], metaData) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/edit-meta-data-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.editableMetaData = _.filter(angular.copy(metaData), (m) => {
          return !!m.editable;
        })
        $scope.ids = ids;

        $scope.cancel = self.$mdDialog.cancel;
        //////////////////////

        $scope.onMetaDataValueChange = (metaData, value: string) => {
          metaData.value = value;
        }

        $scope.onReset = () => {
          $scope.editableMetaData.forEach((m) => {
            m.value = undefined;
          })
        }

        $scope.onResetValue = (metaData, isReset: boolean) => {
          metaData.value = undefined;
          metaData.resetValue = isReset;
        }

        $scope.submit = (form) => {
          const updatedMetaData = _.filter($scope.editableMetaData, (m) => {
            return !!m.value || !!m.resetValue;
          })

          if (!updatedMetaData.length) {
            $scope.cancel();
          } else {
            const metaData: { value: string; key: string }[] = updatedMetaData.map((m) => {
              return {
                key: m.key,
                value: m.resetValue ? null : m.value
              }
            })

            const payload = {
              ids: ids,
              metaData: metaData
            }

            if (form) {
              form.$setSubmitted(true);
              if (form.$valid) {
                self.$mdDialog.hide(payload);
              }
            }
          }

        }


      }
    })
  }

  editOperationalContacts(operationalContacts: OperationalContactModel[], event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/edit-operational-contacts-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, splitService) {
        const siteOperationalContactTypes = splitService.getOperationalContactTypes() || [];
        $scope.operationalContacts = angular.copy(operationalContacts);

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onReset = () => {
          $scope.operationalContacts = angular.copy(operationalContacts);
        };

        $scope.onAdd = () => {
          const operationalContact: OperationalContactModel = $scope._getEmptyOperationalContact();
          const operationalContactsCopy = angular.copy($scope.operationalContacts);
          operationalContactsCopy.push(operationalContact);

          $scope.operationalContacts = operationalContactsCopy;
        };

        $scope.onRemove = (index: number, form) => {
          const operationalContactsCopy = angular.copy($scope.operationalContacts);
          operationalContactsCopy.splice(index, 1);

          $scope.operationalContacts = operationalContactsCopy;
        };

        $scope.onChange = (operationalContactModel: OperationalContactModel, index: number) => {
          if (index > -1) {
            const operationalContactsCopy = angular.copy($scope.operationalContacts);
            operationalContactsCopy[index] = operationalContactModel;

            $scope.operationalContacts = operationalContactsCopy;
          }
        };

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.operationalContacts);
            }
          }
        };

        $scope._getEmptyOperationalContact = (): OperationalContactModel => {
          return {
            name: undefined,
            phoneNo: undefined,
            contactType: siteOperationalContactTypes[0]
          }
        };

      }
    });

  }
}

angular
  .module('bringoz.admin.commons')
  .service('commonsDialogService', CommonsDialogService);

